import { defineStore } from "pinia";

export const useVoiceMachineStore = defineStore("voiceMachine", {
  state: () => ({}),
  actions: {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setTimeRange(_source: VoiceSource, _fileReference: string, _startTime: number, _endTime?: number) {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setShouldTrackAudio(_source: VoiceSource, _fileReference: string, _state: boolean) {},
  },
});

type VoiceSource = "player" | "transcript" | "summary-notes" | "check-evidence" | "agent-citation";
